module.exports = __webpack_public_path__ + "static/NOI0-f06fbed9ddb56e8a2b7181ae6a605a6d.png";